import { Box, Text } from '@modusign/design-system';
import { useGetUserInvitation } from '@modusign/openapi-client-user';
import { useSelector } from 'react-redux';

import { getName } from '@app/store/user/user/selectors';

export default function InvitationCaution() {
  const userInvitation = useGetUserInvitation();
  const userName = useSelector(getName);

  if (!userInvitation.data) {
    return null;
  }

  const { workspaceName } = userInvitation.data;

  return (
    <>
      <Box mb={7}>
        <Text as="p" fontSize="15px" fontWeight="bold" mb={2}>
          문서 보안에 유의해주세요
        </Text>
        <Text>
          앞으로 ‘{workspaceName}’에서 서명 요청하거나 요청받은 문서의 소유권은 해당 워크스페이스에
          귀속되며, 최고 관리자 및 공유받은 다른 멤버가 문서를 열람할 수 있습니다.
        </Text>
      </Box>
      <Box>
        <Text as="p" fontSize="15px" fontWeight="bold" mb={2}>
          나의 개인 정보를 보호하세요
        </Text>
        <Text>
          ‘{userName}’님 외 타인에게 공개되면 안 되는 개인 정보가 포함된 문서는 별도의 개인 계정을
          이용해 체결·관리해 주시기 바랍니다.
        </Text>
      </Box>
    </>
  );
}
